import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HelperService} from '../../../shared/services/helper.service';
import {DataService} from '../../../shared/services/data.service';
import {Subscription} from 'rxjs';
import {ApiServices} from '../../../shared/services/api.service';
import {Filters, ProductVariant, Wheels} from '../../../shared/interfaces/wheels';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { MyProfile } from 'src/app/shared/interfaces/MyAccount.interface';
import {MetaService} from '../../../shared/services/meta.service';

@Component({
  selector: 'app-wheels-listing',
  templateUrl: './wheels-listing.component.html',
  styleUrls: ['./wheels-listing.component.scss']
})
export class WheelsListingComponent implements OnInit {
  per_page:any = null;
  isDownloding:boolean = false;
  vehicleFormData: any;
  searchVehicleSub: Subscription;
  vehicleSubscription: Subscription;
  filters: Filters;
  products = [];
  year: any;
  make: any;
  model: any;
  modification: any;
  subModel: any;
  loadProducts = false;
  productsFound: boolean;
  queryParams: any;
  loadMoreProducts = false;
  hasNextPage = false;
  @ViewChild('content') content: TemplateRef<any>;
  viewDetailLoader = false;
  checkfitment = false;
  productDetail: ProductVariant;
  vehicle: any;
  vehicleWheels: [ProductVariant];
  diameter: number;
  activeDiameter = null;
  deliveryDate: any;
  noDataFound: boolean;
  showFilters = false;
  fitmentData: any;
  is_hide_cost = null;
  isRear = 0;
  profileData: MyProfile;
  showWeight = false;
  showHubBore = false;

  serchvehiclehome = 0;
  front_rim_diameter:any;
  front_rim_width:any;
  front_bolt_pattern:any;
  rear_rim_diameter:any;
  rear_rim_width:any;
  search_by_size = true;
  showFirstIcon: boolean;
  show_center_bore :boolean = false;
  show_wheel_weight:boolean = false; 


  constructor(
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private apiService: ApiServices,
    private dataService: DataService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private metaService: MetaService
  ) {
    helperService.setPageTitle(activatedRoute.snapshot.data.title);
    this.subscribes();
    this.show_center_bore = localStorage.getItem("show_center_bore") != null ? true : false;
    this.show_wheel_weight = localStorage.getItem("show_wheel_weight") != null ? true : false;
  }

  subscribes(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        this.year = params.year;
        this.make = params.make;
        this.model = params.model;
        this.modification = params.modification;
        this.subModel = params.subModel;

        this.front_rim_diameter = params.front_rim_diameter;
        this.front_rim_width = params.front_rim_width;
        this.front_bolt_pattern = params.front_bolt_pattern;
        this.rear_rim_diameter = params.rear_rim_diameter;
        this.rear_rim_width = params.rear_rim_width;

        setTimeout(()=>{
          if (this.show_center_bore == true) {
            document.querySelectorAll(".hub_bore").forEach((hb)=>{
              hb.classList.remove("d-none");
            })
          }
  
          if (this.show_wheel_weight == true) {
            document.querySelectorAll(".wheel_weight").forEach((ww)=>{
              ww.classList.remove("d-none");
            })
          }
        }, 500)

        this.dataService.searchSelections.next({
          year: this.year,
          make: this.make,
          model: this.model,
          modification: this.modification,
          subModel: this.subModel,


          front_rim_diameter: this.front_rim_diameter,
          front_rim_width: this.front_rim_width,
          front_bolt_pattern: this.front_bolt_pattern,
          rear_rim_diameter: this.rear_rim_diameter,
          rear_rim_width: this.rear_rim_width
        });

        this.queryParams = params;
        this.activeDiameter = this.queryParams.rim_diameter;
        // this.diameter = this.queryParams.rim_diameter;
        
        if (params.hasOwnProperty('search_by_size') && params.search_by_size){
          
          if(params.rear_rim_diameter!='' || params.rear_rim_width != ''){
            this.isRear = 1;
          }
          this.searchBySize();
          this.serchvehiclehome = 1;
        } else {
          this.getAll();
        }
      
        // this.getAll();
      }
    });
    // this.dataService.fitmentData.asObservable().subscribe(fitmentData => this.fitmentData = fitmentData);

  }

  ngOnInit(): void {
    this.getFilters();
    this.dataService.diameter.asObservable().subscribe(diameter => {
      if (!diameter) {
        diameter = this.queryParams.rim_diameter;
      }
      this.activeDiameter = diameter;
      this.diameter = diameter;
    });
    this.dataService.myAccountData.asObservable().subscribe(
      myAccountData => {
        if (myAccountData) {
          this.profileData = myAccountData.my_profile;
          // Security: Use secure method to determine cost hiding
          this.is_hide_cost = this.helperService.shouldHideCost(this.profileData) ? 1 : 0;
        }
      }
    );    
    this.metaService.updateCanonicalURL();
  }


  getFilters = () => {
    this.apiService.getFilters(this.queryParams).subscribe(
      response => {
        this.filters = response.data.filters;
      }
    );
  }
  getVehicleData = () => {
    const data = {
      year: this.year,
      make: this.make,
      model: this.model
    };
    this.vehicleSubscription = this.apiService.getVehicles(data).subscribe(
      (res: any[]) => {
        if (res.length) {
          const param = this.helperService.setVehicleWheelParams(res);
          this.router.navigate(['serchvehicle'], { queryParams: {...data, ...param}});
        }
      }
    );
  }

  downloadAsPDF(){
    this.show_center_bore = localStorage.getItem("show_center_bore") != null ? true : false;
    this.show_wheel_weight = localStorage.getItem("show_wheel_weight") != null ? true : false;
    this.isDownloding = true;
    const params = {...this.queryParams};
    if(this.show_wheel_weight) {
      params['show_weight'] = 1;
    }
    if(this.show_center_bore) {
      params['show_hubbore'] = 1;
    }
    delete params["per_page"];
    this.apiService.downloadSearchProducts(params).subscribe(response=>{
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      this.isDownloding = false;
      link.download = 'search-by-size.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
    })
  }

  getSearchData = () => {
    this.loadProducts = true;
    this.searchVehicleSub = this.apiService.searchVehicles(this.vehicleFormData).subscribe(
      response => {
        this.loadProducts = false;
        this.products = response.data.products.data;
        this.filters = response.data.filters;
        this.resolveMetaTags();
      },
      err => {
        console.log('error', err.error);
      }
    );
  }

  resolveMetaTags(): void {
    this.helperService.setCustomMeta({
      title: this.activatedRoute.snapshot.data.breadcrumbs.title,
      description: this.activatedRoute.snapshot.data.breadcrumbs.description,
    });
  }

  getAll = () => {
    // this.loadProducts = true;
    this.searchVehicleSub = this.apiService.getAllProducts(this.queryParams).subscribe(
      (response: Wheels) => {
        // if (response.data.products.data) {
        //   this.dataService.checkFitment.next(true);
        // } else {
        //   this.dataService.checkFitment.next(false);
        // }
        // @ts-ignore
        this.products = [...this.products, ...response.data.products.data];  
        if(!this.products.length) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
        }
        this.loadMoreProducts = false;
        // this.loadProducts = false;
        //  this.filters = response.data.filters;
        if (response.data.products.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
      }, err => {
        this.loadProducts = false;
        this.loadMoreProducts = false;
      }
    );
  }

  searchBySize = () => {
    // this.loadProducts = true;
    this.searchVehicleSub = this.apiService.getProductsByCustomSize(this.queryParams).subscribe(
      (response: Wheels) => {
        this.products = [...this.products, ...response.data.products.data];
        
        if(!this.products.length) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
        }
        this.loadMoreProducts = false;
        // this.loadProducts = false;
        //  this.filters = response.data.filters;
        this.per_page = response.data.products.total;
        if (response.data.products.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
        
      }, err => {
        this.loadProducts = false;
        this.loadMoreProducts = false;
      }
    );
  }


  // tslint:disable-next-line:typedef use-lifecycle-interface
  ngOnDestroy() {
    this.searchVehicleSub.unsubscribe();
    if (this.vehicleSubscription) {
      this.vehicleSubscription.unsubscribe();
    }
  }

  onFilterSelections = (params) => {
    this.products = [];
    
    // IMPORTANT: Reset to page 1 when applying filters
    params.page = 1;
    
    if(this.serchvehiclehome){
      // console.log(params);
      // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
      this.router.navigate(['/search-by-size'], {queryParams: params});
      // this.searchBySize();
    } else {
      this.router.navigate(['/serchvehicle'], {queryParams: params});
    }
    // this.router.navigate(['/serchvehicle'], {queryParams: params});
  }

  changePerPage = ($event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.perPage = $event.target.value;
    
    // IMPORTANT: Reset to page 1 when changing items per page
    params.page = 1;
    
    if(this.serchvehiclehome){
      // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
      this.router.navigate(['/search-by-size'], {queryParams: params});
    } else {
      this.router.navigate(['/serchvehicle'], {queryParams: params});
    }

    // this.router.navigate(['/serchvehicle'], {queryParams: params});
  }

  loadMore = () => {
    this.loadMoreProducts = true;
    setTimeout( () => {
      const params = Object.assign({}, this.queryParams);
      params.page = params.page ? ++params.page : 2;

      if(this.serchvehiclehome){
        // this.searchBySize();
        // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
        this.router.navigate(['/search-by-size'], {queryParams: params});
      } else {
        this.router.navigate(['/serchvehicle'], {queryParams: params});
      }

    }, 500);
  }

  getWheelsByDiameter = (diameter: number) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.rim_diameter = diameter;
    this.activeDiameter = diameter;

    if(this.serchvehiclehome){
      // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
      this.router.navigate(['/search-by-size'], {queryParams: params});
    } else {
      this.getFilters();
      this.router.navigate(['/serchvehicle'], {queryParams: params});
    }
    // this.router.navigate(['/serchvehicle'], {queryParams: params});
  }

  sortBy = (event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.sortBy = event.target.value;
    if(this.serchvehiclehome){
      // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
      this.router.navigate(['/search-by-size'], {queryParams: params});
    } else {
      this.router.navigate(['/serchvehicle'], {queryParams: params});
    }
    // this.router.navigate(['/serchvehicle'], {queryParams: params});
  }


  onViewDetail = (product: ProductVariant, year=0, modle=0, make=0) => {
    if(this.route.snapshot.url[0].path=='search-by-size'){
      this.onViewDetailSearchBySize(product);
    } else {
      this.onViewDetailSearchByVehicle(product);
    }
  }

  onViewDetailSearchBySize = (product: ProductVariant) => {
    // console.log('Search BY Size');

    this.productDetail = product;
    product.loading = true;

    const formParams = {
      bolt_pattern: product.bolt_pattern,
      model_id: product.model_id,
      brand_id: product.brand_id,
      product_id: product.id,
      width: product.rim_width,
      diameter: product.rim_diameter,
      rear_width: product.rear_rim_width?product.rear_rim_width: null,
      rear_diameter: product.rear_rim_diameter?product.rear_rim_diameter: null
    };

    this.deliveryDate = this.getDeliveryDate(product);

    this.searchVehicleSub = this.apiService.searchSize(formParams).subscribe(
      (wheels: any) => {
        this.modalService.open(this.content);
        product.loading = false;

        if (wheels.data.length) {
          this.vehicleWheels = wheels.data;
          // this.dataService.checkFitment.next(true);
          this.checkfitment = true;
          this.productDetail = product;
          this.vehicle = this.year + ' ' + this.make + ' ' + this.model;
        } else {
          // this.modalService.open(this.content);
          product.loading = false;
          // this.dataService.checkFitment.next(false);
          this.checkfitment = false;

        }
      }, error => {
        this.dataService.checkFitment.next(false);
        this.checkfitment = false;
      }
    );
  }

  onViewDetailSearchByVehicle = (product: ProductVariant) => {
    this.productDetail = product;
    if (!this.year && !this.model && !this.make) {
      product.loading = false;
      this.modalService.open(this.content);
      return;
    }

    product.loading = true;

    const formParams = {
      bolt_pattern: product.bolt_pattern,
      // bolt_pattern: this.fitmentData.bolt_pattern,
      model_id: product.model_id,
      // rim_diameter: params.rim_diameter,
      // width: params.width
      product_id: product.product_id
    };

    this.deliveryDate = this.getDeliveryDate(product);

    this.searchVehicleSub = this.apiService.searchSize(formParams).subscribe(
      (wheels: any) => {
        this.modalService.open(this.content);
        product.loading = false;
        if (wheels.data.length) {
          this.vehicleWheels = wheels.data;
          // this.dataService.checkFitment.next(true);
          this.checkfitment = true;
          this.productDetail = product;
          this.vehicle = this.year + ' ' + this.make + ' ' + this.model;
        } else {
          // this.modalService.open(this.content);
          product.loading = false;
          // this.dataService.checkFitment.next(false);
          this.checkfitment = false;

        }
      }, error => {
        this.dataService.checkFitment.next(false);
        this.checkfitment = false;

      });
  }

  onClear = (isClear) => {
    if (isClear) {
      if(this.serchvehiclehome){
         let params:any = {};
         params.front_rim_diameter = this.front_rim_diameter;
         params.front_rim_width = this.front_rim_width;
         params.front_bolt_pattern = this.front_bolt_pattern;
         params.rear_rim_diameter = this.rear_rim_diameter;
         params.rear_rim_width = this.rear_rim_width;
         params.search_by_size = this.search_by_size;

         // console.log(params);

        // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
        this.router.navigate(['/search-by-size'], {queryParams: params});
      } else {
        // this.router.navigate(['/serchvehicle'], {queryParams: params});
        this.getVehicleData();
      }

    }
  }

  getDeliveryDate = (product: ProductVariant) => {
    this.apiService.getUserLocation().subscribe(
      response => {
        let countryCode = 'AE';
        if (response.countryCode) {
          countryCode = response.countryCode;
        }
        this.deliveryDate = this.helperService.deliveryDate(countryCode, product.brand);
      }
    );
  }

  checkInStock(product: any) {
    var inStock = false;
    if(this.isRear && product.rear_size!=null) {
      if(product.rear_in_stock_quantity > 0 && product.total_quantity > 0) {
        inStock = true
      }
    } else {
      if (product.total_quantity > 0 || product.product_inventory[0]?.eta_qty > 0) {
        inStock = true
      }
    }

    return inStock;
  }

  onhideFilters(): void {
    this.showFilters = false;
  }

  ShowHideWeightHub = (type) =>  {
    if(type == 'w'){
      this.showWeight = !this.showWeight;
    }
    if(type == 'h'){
      this.showHubBore = !this.showHubBore;
    }



  }

  toggleIcon() {
    this.showFirstIcon = !this.showFirstIcon;
  }
}
